import { gql } from 'graphql-tag';

const UpdateEventEvidenceMutation = gql`
  mutation updateEventEvidence(
    $id: ID!
    $eventId: ID!
    $folderNumber: Int!
    $evidenceId: ID!
    $orderIndex: Int!
    $requiredActors: Int!
    $content: String
    $name: String
  ) {
    updateEventEvidence(
      id: $id
      eventId: $eventId
      folderNumber: $folderNumber
      evidenceId: $evidenceId
      orderIndex: $orderIndex
      requiredActors: $requiredActors
      content: $content
      name: $name
    ) {
      id
      eventId
      evidenceId {
        id
        name
      }
      folderNumber
      content
      name
      pdf {
        url
      }
      orderIndex
      requiredActors
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const updateEventEvidence = async ({ client, params }) => {
  params.data.evidenceId = params.data.evidenceId.id;
  const result = await client.mutate({
    mutation: UpdateEventEvidenceMutation,
    variables: { ...params.data },
  });
  return {data:result.data.updateEventEvidence};
};
